import { Button } from '@mui/material';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

import useProfileImage from '../../../hooks/useProfileImage';
import { getTimeZoneAbbreviation } from '../../../hooks/useUserTimeZone';

const BuddyProfileTop = ({ meta }) => {
  const user = useSelector((state) => state.login.user);
  const profileImage = useProfileImage(user.profilePic);
  const fullName = user?.middleName
    ? `${user?.firstName} ${user?.middleName} ${user?.lastName}`
    : `${user?.firstName} ${user?.lastName}`;

  const navigate = useNavigate();

  const onEditProfile = () => {
    navigate('/profile');
  };

  return (
    <div
      style={{
        display: 'flex',
        border: '1px solid #BCCEFF',
        margin: '16px',
        padding: '20px',
        borderRadius: '16px',
        backgroundColor: 'white',
        gap: '16px',
        // justifyContent: 'space-evenly',
      }}
    >
      <div style={{ display: 'flex', gap: '16px', flex: 'none' }}>
        <div>
          <img
            style={{ height: '100px', width: '100px', objectFit: 'contain', borderRadius: '4px' }}
            src={profileImage}
            alt={fullName}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span style={{ fontSize: '24px', fontWeight: 'bold' }}>{fullName}</span>
          <span>
            Last Login :{' '}
            {moment(user?.lastLoggedInAt).format(
              user.country === 'India' ? 'Do MMMM YYYY, h:mm a' : 'MMMM Do YYYY, h:mm a'
            )}{' '}
            {getTimeZoneAbbreviation()}
          </span>
          <Button
            startIcon={
              <img
                src="/assets/images/buddy/EditProfile.png"
                style={{ height: '14px', width: '14px', objectFit: 'contain' }}
                alt="EditProfile"
              />
            }
            size="small"
            variant="contained"
            onClick={onEditProfile}
            sx={{
              textTransform: 'none',
              width: '120px',
              marginTop: '8px',
              color: '#FFFFFF',
              backgroundColor: '#3D71FF',
              '&:hover': { backgroundColor: '#3D71FF', color: '#FFFFFF' },
            }}
          >
            Edit Profile
          </Button>
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-evenly', flex: 1 }}>
        <div style={{ backgroundColor: '#BCCEFF', width: '1px', height: '100%' }} />
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              style={{ width: '20px', height: '20px', objectFit: 'contain', marginRight: '10px' }}
              src="/assets/images/buddy/SafalBuddies.png"
              alt="SafalBuddies"
            />
            <span style={{ display: 'block', width: '180px' }}>SafalBuddies</span>
            <span style={{ whiteSpace: 'nowrap' }}>: {meta?.safalBuddies ?? 0}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              style={{ width: '20px', height: '20px', objectFit: 'contain', marginRight: '10px' }}
              src="/assets/images/buddy/PendingSafalBuddies.png"
              alt="Pending SafalBuddies"
            />
            <span style={{ display: 'block', width: '180px' }}>Pending SafalBuddies</span>
            <span style={{ whiteSpace: 'nowrap' }}>: {meta?.pendingSafalBuddies ?? 0}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              style={{ width: '20px', height: '20px', objectFit: 'contain', marginRight: '10px' }}
              src="/assets/images/buddy/RejectedSafalBuddies.png"
              alt="Rejected SafalBuddies"
            />
            <span style={{ display: 'block', width: '180px' }}>Rejected SafalBuddies</span>
            <span style={{ whiteSpace: 'nowrap' }}>: {meta?.rejectedSafalBuddies ?? 0}</span>
          </div>
        </div>
        <div style={{ backgroundColor: '#BCCEFF', width: '1px', height: '100%' }} />
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              style={{ width: '20px', height: '20px', objectFit: 'contain', marginRight: '10px' }}
              src="/assets/images/buddy/BlockUser.png"
              alt="Blocked Users"
            />
            <span style={{ display: 'block', width: '140px' }}>Blocked Users</span>
            <span style={{ whiteSpace: 'nowrap' }}>: {meta?.blockedUsers ?? 0}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              style={{ width: '20px', height: '20px', objectFit: 'contain', marginRight: '10px' }}
              src="/assets/images/subscription.png"
              alt="Subscriptions #"
            />
            <span style={{ display: 'block', width: '140px' }}>Subscriptions</span>
            <span style={{ whiteSpace: 'nowrap' }}>: {meta?.subscriptions ?? 0}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              style={{ width: '20px', height: '20x', objectFit: 'contain', marginRight: '10px' }}
              src="/assets/images/assetIconNew.png"
              alt="Assets #"
            />
            <span style={{ display: 'block', width: '140px' }}>Assets</span>
            <span style={{ whiteSpace: 'nowrap' }}>: {meta?.assets ?? 0}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuddyProfileTop;
